module.exports = __webpack_public_path__ + "static/media/ariel matic.ff61d140.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/ariel matic.gif
// module id = 381
// module chunks = 0